import { useDocumentPreviewVM } from "presentation/hook/DocumentPreview/useDocumentPreviewVM";
import { memo } from "react";
import { DialogModal, IconButton } from "veronica-ui-component/dist/component/core";
import DocumentPreviewEditContent from "./DocumentPreviewEditContent";

const DocumentPreviewEditModal: React.FC = () => {
    // const [documentPreviewState] = useDocumentPreviewTracked();
    const documentPreviewVM = useDocumentPreviewVM();
    // const { isShowAdjCntrPanel } = documentPreviewState;

    const handleCloseDialog = () => {
        documentPreviewVM.cancelEditModal();
    }



    return <><DialogModal style={{ minWidth: '62vw', minHeight: '90vh' }}
        appendTo='self'
        showButton={false}
        visible={false}
        positions="center"
        resizable={false}
        header={
            <div className="im-charge-data-search-confirm-modal-header">
                <span className="name">{"Add/Remove Container"}</span>
                <IconButton fileName='Icon-cross' size="medium" onClick={handleCloseDialog} tooltipDisable={true} />
            </div>
        }
        dialogContent={<DocumentPreviewEditContent />}
        className="im-charge-data-search-confirm-modal"
    /></>
};

export default memo(DocumentPreviewEditModal);